import { FormProvider, useWatch } from "react-hook-form";
import { Button } from "primereact/button";
import { ITopicRuleFormProps } from "./TopicRule.model";
import { FormRow } from "../../components/FormRow";
import { CustomInput } from "../../components/CustomInput";
import { CustomSelect } from "../../components/CustomSelect";
import { TopicService } from "../../service/Topic/topic.service";
import { interviewQuestionService } from "../../service/InterviewQuestion/interviewQuestion.service";
import { useEffect, useState } from "react";

interface IQuestionCounts {
  high: number;
  medium: number;
  low: number;
}

const TopicRuleForm = ({ methods, onSubmit, isEdit }: ITopicRuleFormProps) => {
  const [topicOptions, setTopicOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const [questionCounts, setQuestionCounts] = useState<IQuestionCounts | null>(null);

  const selectedTopic = useWatch({ control: methods.control, name: "topic" });

  const loadTopics = async () => {
    const res = await TopicService.getTopics(true);
    const sortedData = [...res.data].sort((a, b) => a.id - b.id);
    const options = sortedData.map((topic) => ({
      label: topic.name,
      value: topic.id,
    }));
    setTopicOptions(options);
  };

  useEffect(() => {
    loadTopics();
  }, []);

  useEffect(() => {
    if (selectedTopic) {
      interviewQuestionService.getCountByTopic(selectedTopic).then((res) => {
        setQuestionCounts(res.data);
      });
    } else {
      setQuestionCounts(null);
    }
  }, [selectedTopic]);

  const availableBadge = (count: number | undefined) => {
    if (count === undefined) return null;
    return (
      <small className="ml-2" style={{ color: "#6c757d" }}>
        (Available: <strong>{count}</strong>)
      </small>
    );
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className="p-fluid">
        <FormRow label="Topic *" name="topic">
          <CustomSelect
            name="topic"
            options={topicOptions}
            placeholder="Select topic"
          />
        </FormRow>

        <FormRow label="Year of Experience *" name="year_of_experience">
          <CustomInput name="year_of_experience" type="number" />
        </FormRow>

        <FormRow
          label={
            <span>
              High Questions *{availableBadge(questionCounts?.high)}
            </span>
          }
          name="high_no_of_question"
        >
          <CustomInput name="high_no_of_question" type="number" />
        </FormRow>

        <FormRow
          label={
            <span>
              Medium Questions *{availableBadge(questionCounts?.medium)}
            </span>
          }
          name="medium_no_of_question"
        >
          <CustomInput name="medium_no_of_question" type="number" />
        </FormRow>

        <FormRow
          label={
            <span>
              Low Questions *{availableBadge(questionCounts?.low)}
            </span>
          }
          name="low_no_of_question"
        >
          <CustomInput name="low_no_of_question" type="number" />
        </FormRow>

        {/* Submit */}
        <div className="mt-4 flex justify-content-end">
          <Button
            label={isEdit ? "Update Topic Rule" : "Create Topic Rule"}
            type="submit"
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default TopicRuleForm;
